import { Modal } from 'antd'

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    
    window.location.hostname === '[::1]' ||
    
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);


/*if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./service-worker.js').then(function(registration) {
    // Registration was successful
    console.log('ServiceWorker registration successful with scope: ', registration.scope);
}).catch(function(err) {
    // registration failed :(
      console.log('ServiceWorker registration failed: ', err);
    });
}*/


export default function register() {
  if ('serviceWorker' in navigator) {

    const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swFileName = process.env.NODE_ENV === 'production' 
      ? 'service-worker.js'       
      : 'custom-sw.js'

      const swUrl = `${process.env.PUBLIC_URL}/${swFileName}`;
    
      if (isLocalhost) { checkValidServiceWorker(swUrl) } 
      else { registerValidSW(swUrl) }
    });
  }
}

const askUserToUpdate = reg => {

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });

  if (reg && reg.waiting) {
    reg.waiting.postMessage({ type: 'SKIP_WAITING' })
  }

  return

  return Modal.confirm({
    onOk: async () => {
      //console.log('SKIP_WAITING_')
      
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });

      if (reg && reg.waiting) {
        reg.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
    },

    onCancel: () => {
      Modal.destroyAll();
    },
    icon: null,
    title: 'Доступно обновление.',
    content: 'Доступна новая версия приложения. Для обновления нажмите "Обновить" (страница перезагрузится) ',
    cancelText: 'Отложить',
    okText: 'Обновить'
  });
};

function registerValidSW(swUrl) {
    navigator.serviceWorker.register(swUrl).then(registration => {      
      
      setInterval(()=>{registration.update();}, 3600000) 
      
      if(registration.waiting) {        
        askUserToUpdate(registration)
      }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              askUserToUpdate(registration)
              console.log('New content is available; please refresh.');              
            } else {
              console.log('Content is cached for offline use.');
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl) {
 
  fetch(swUrl)
    .then(response => {
      
      if (
        response.status === 404 ||
        response.headers.get('content-type').indexOf('javascript') === -1
      ) {
        
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
      
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
